import { render, staticRenderFns } from "./modalAnalisar.vue?vue&type=template&id=4063c406"
import script from "./modalAnalisar.vue?vue&type=script&lang=js"
export * from "./modalAnalisar.vue?vue&type=script&lang=js"
import style0 from "./modalAnalisar.vue?vue&type=style&index=0&id=4063c406&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports